import { api } from '../DefaultService'; 
import { DashboardSchema } from './schemas';
import { DashboardData } from './types';

const ENDPOINT = 'v1/dash/summary';

export const getDashboardSummaryAsync = async (): Promise<DashboardData> => {
  try {
    const response = await api.get(ENDPOINT);
    const parsedData = DashboardSchema.parse(response.data);

    return parsedData;
  } catch (error) {
    console.error('Erro ao carregar dados da dashboard:', error);

    return DashboardSchema.parse({}); 
  }
};
